import React, {Fragment} from "react"
import {Divider} from "./components"
import {FacetState} from "../../../../models/FacetsState"
import SingleFacet from "../singleFacet"
import AlphabeticallySortedFacetList from "../alphabeticallySortedFacetList"
import {TextModel} from "../../../../models/Text"
import FacetsWrapper from "../alphabeticallySortedFacetList/FacetsWrapper"

interface FacetListProps {
    filterName: string
    facets: FacetState[]
    handleSetFacet: (facetValue: string, filterName: string) => void
    isEnterKeyDown: boolean
    updateNumberOfFacetsLoaded: (filterName: string) => void
    lazyLoadFacets: boolean
    sortFacetsAlphabetically?: boolean
    compositeFilter: boolean
    showBorderAfterTopFive: boolean
    siteUrl: string
    popularFacetCount: number
    text: TextModel
}

export const FacetList = ({
    filterName,
    facets,
    handleSetFacet,
    isEnterKeyDown,
    updateNumberOfFacetsLoaded,
    lazyLoadFacets,
    showBorderAfterTopFive,
    siteUrl,
    popularFacetCount,
    text,
    sortFacetsAlphabetically = false,
    compositeFilter,
}: FacetListProps) => {
    const handleScroll = e => {
        if (lazyLoadFacets) {
            const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10
            if (bottom) {
                updateNumberOfFacetsLoaded(filterName)
            }
        }
    }

    if (sortFacetsAlphabetically || compositeFilter) {
        return (
            <AlphabeticallySortedFacetList
                filterName={filterName}
                facets={facets}
                handleSetFacet={handleSetFacet}
                lazyLoadFacets={lazyLoadFacets}
                siteUrl={siteUrl}
                updateNumberOfFacetsLoaded={updateNumberOfFacetsLoaded}
                isEnterKeyDown={isEnterKeyDown}
                popularFacetCount={popularFacetCount}
                text={text}
            />
        )
    }
    return (
        <FacetsWrapper onScroll={handleScroll} dataTestId={`plp-horizontal-filters-${filterName}-scroll`}>
            <div>
                {facets?.length > 0 &&
                    facets.map((facet, i) => {
                        return (
                            <Fragment key={facet.v}>
                                {i === 5 && showBorderAfterTopFive && <Divider />}
                                <SingleFacet
                                    facet={facet}
                                    handleSetFacet={() => handleSetFacet(facet.v, filterName)}
                                    filterName={filterName}
                                    showCount
                                    shouldGetFocus={i === 0 && isEnterKeyDown}
                                    key={facet.n}
                                    siteUrl={siteUrl}
                                />
                            </Fragment>
                        )
                    })}
            </div>
        </FacetsWrapper>
    )
}

export default FacetList
